import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=006e1ec3&scoped=true&"
import script from "./UploadImage.vue?vue&type=script&lang=ts&"
export * from "./UploadImage.vue?vue&type=script&lang=ts&"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=006e1ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e1ec3",
  null
  
)

export default component.exports